import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { isMonitoringGatewayRequest } from '../base/url.store-forward.gateway';

/**
 * Añade X-App-Key a peticiones hacia el API Gateway de logs.
 * No loguea ni expone la clave en errores.
 */
@Injectable()
export class LogsAppKeyInterceptor implements HttpInterceptor {
  intercept(
    request: HttpRequest<unknown>,
    next: HttpHandler
  ): Observable<HttpEvent<unknown>> {
    if (!isMonitoringGatewayRequest(request.url)) {
      return next.handle(request);
    }
    const appKey = environment.logsAppKey;
    if (!appKey) {
      return next.handle(request);
    }
    let headers = request.headers.set('X-App-Key', appKey);
    const body = request.body;
    if (
      !headers.has('Content-Type') &&
      body !== null &&
      !(body instanceof FormData)
    ) {
      headers = headers.set('Content-Type', 'application/json; charset=utf-8');
    }
    return next.handle(request.clone({ headers }));
  }
}
